<ng-container *transloco="let t">
    @let required = required$ | async;
    @let optionList = options$ | async;
    @let selectedValues = selectedValues$ | async;
    <ng-container
        *ngIf="{
            disabled: disabled.$ | async,
            values: values.$ | async,
        } as data"
    >
        @let control = ngControl.control;
        @if (control) {
            <div
                [class]="'bazis-control ' + cssClassSizeControl"
                [ngClass]="{
                    'bazis-control--focused': isFocused,
                    'bazis-control--invalid': ngControl.control.invalid,
                    'bazis-control--disabled': data.disabled,
                    'bazis-control--dirty': ngControl.control.dirty,
                    'bazis-control--empty': !ngControl.control.value?.length,
                }"
                clickOutside
                (clickOutside)="hideList()"
            >
                <bazis-toolbar class="bh-margin-bottom-1x">
                    <bazis-label
                        slot="start"
                        [id]="attrId"
                        [isMajor]="hasTitleMajor"
                        [isEmptyLabel]="isEmptyLabel"
                        [title]="title || t(titleKey, titleParams)"
                        [required]="required"
                        class="bh-no-margin"
                    >
                        @if (tooltipKey) {
                            <bazis-interrogation
                                [slot]="tooltipSettings?.targetSide"
                                iconSize="compact"
                                [tooltipText]="t(tooltipKey, tooltipParams)"
                                [tooltipOffset]="[-8, 4]"
                                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                                [icon]="icons.interrogation"
                                [type]="interrogationType"
                            ></bazis-interrogation>
                        }
                    </bazis-label>
                    @if (control.value?.length) {
                        <div
                            slot="end"
                            class="bh-align-items-center"
                        >
                            <span class="bh-padding-horizontal-1x">{{ control.value.length }}</span>
                            <bazis-icon
                                name="cross"
                                size="compact"
                                class="bazis-text_secondary bh-pointer"
                                (click)="onClear()"
                            ></bazis-icon>
                        </div>
                    }
                </bazis-toolbar>

                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--activated]="showList"
                    [class.bazis-control__field-group--disabled]="data.disabled"
                    [class.bazis-control__field-group--focused]="isFocused"
                >
                    <bazis-control-field-start
                        [isClickable]="isLeftIconClickable"
                        [icon]="leftIcon"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        (actionClick)="onLeftIconClick($event)"
                    >
                    </bazis-control-field-start>

                    <div class="bazis-control__field">
                        <bazis-select-native
                            [attrId]="attrId"
                            [options]="data.optionList"
                            [placeholder]="placeholder || t(placeholderKey)"
                            (focused)="focusField($event)"
                            (blured)="blurField($event)"
                        ></bazis-select-native>
                        <!-- Прекрасный кастомный селект -->
                        <div
                            class="bazis-select"
                            aria-hidden="true"
                        >
                            <div
                                class="bazis-select__trigger"
                                (click)="toggleList()"
                            >
                                <span class="bazis-text_secondary">{{
                                    control.value.length
                                        ? placeholderKeyValue
                                            ? t(placeholderKeyValue)
                                            : placeholderKey
                                              ? t(placeholderKey)
                                              : placeholder
                                        : placeholderKey
                                          ? t(placeholderKey)
                                          : placeholder
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <bazis-control-select-end
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        [iconUp]="iconUp"
                        [iconDown]="iconDown"
                        [showList]="showList"
                        (toggled)="toggleList()"
                    >
                    </bazis-control-select-end>

                    <div
                        class="bazis-list bazis-list_control-dd"
                        [hidden]="!showList"
                    >
                        @if (optionList?.length) {
                            <div
                                class="bazis-item bazis-checkbox"
                                [ngClass]="{
                                    'bazis-checkbox_mixed':
                                        selectedValues.length > 0 &&
                                        selectedValues.length < optionList.length,
                                    'bazis-item--selected': selectedValues.length === optionList.length,
                                }"
                                (click)="toggleAll(selectedValues, optionList)"
                            >
                                <span class="bazis-checkbox__label bh-no-margin">
                                    {{ t('action.selectAll') }}
                                </span>
                            </div>

                            <hr class="bh-margin-vertical-1x" />
                        }

                        @for (option of optionList; track $index) {
                            <bazis-multiple-selection-option
                                [option]="option"
                                [byCheckbox]="byCheckbox"
                                [multiple]="true"
                                [values]="data.values"
                                (toggled)="toggleValue(option.id)"
                            ></bazis-multiple-selection-option>
                        }

                        @if (emptyListKey && optionList && optionList.length === 0) {
                            {{ t(emptyListKey) }}
                        }
                    </div>
                </div>

                @if (selectedValues?.length) {
                    <div class="bazis-tags-group bh-margin-top-1x">
                        @for (selected of selectedValues; track selected.id; let i = $index) {
                            @if (i < displayCount) {
                                <div class="bazis-tag">
                                    <span class="bh-text-capitalize">
                                        {{
                                            selected.$snapshot.name ||
                                                t(
                                                    selected.$snapshot.nameKey,
                                                    selected.$snapshot.nameParams
                                                )
                                        }}
                                    </span>
                                    @if (!isDisabled) {
                                        <button (click)="toggleValue(selected.id)">
                                            <bazis-icon
                                                [name]="icons.trash"
                                                size="mini"
                                            ></bazis-icon>
                                        </button>
                                    }
                                </div>
                            }
                        }
                        @if (selectedValues.length > displayCount) {
                            <div
                                class="bazis-tag bh-pointer"
                                (click)="toggleList()"
                            >
                                <span>+ {{ selectedValues.length - displayCount }}</span>
                                <button (click)="toggleValues($event)">
                                    <bazis-icon
                                        [name]="icons.trash"
                                        size="mini"
                                    ></bazis-icon>
                                </button>
                            </div>
                        }
                    </div>
                }

                <div class="bazis-control__error">
                    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
                </div>

                @if (noteKey) {
                    <div class="bazis-control__note">
                        {{ noteKey }}
                    </div>
                }

                <ng-content select="comment"></ng-content>
            </div>
        }
    </ng-container>
</ng-container>
